<template>
  <div class="new-section">
    <div class="m-container">
      <!-- registration section -->
      <div class="row">
        <!-- registration form -->
        <div class="col-xs-12 col-sm-12 col-md-6 the-form">
          <div class="form-body">
            <q-linear-progress indeterminate v-if="loading"></q-linear-progress>
            <!-- form -->
            <q-form @submit="register" id="register-form" v-if="!registerationComplete">

              <!-- form inputs -->
              <label>Full Name</label>
              <q-input 
                type="name" 
                reactive-rules 
                label-color="secondary" 
                filled 
                v-model="formData.name"
                label="Enter Full Name" 
                lazy-rules 
                :rules="formRules.name"
              />

              <label>Email</label>
              <q-input 
                type="email" 
                reactive-rules 
                label-color="secondary" 
                filled 
                v-model="formData.email"
                label="Enter Email" 
                lazy-rules 
                :rules="formRules.email"
              />

              <label>Gender</label>
              <q-select 
                emit-value 
                map-options 
                reactive-rules 
                label-color="secondary" 
                filled
                v-model="formData.gender" 
                :options="options" 
                label="Enter Gender"
                :rules="formRules.gender"
              />

              <label>Type of User</label>
              <q-select 
                emit-value 
                map-options 
                reactive-rules 
                label-color="secondary" 
                filled
                v-model="formData.type" 
                :options="userTypeOptions" 
                label="Select type of user"
                :rules="formRules.type"
              />

              <label>Age</label>
              <q-input 
                type="nubmer" 
                emit-value 
                map-options 
                reactive-rules 
                label-color="secondary" 
                filled
                v-model="formData.age" 
                label="Your Age"
                :rules="
                [
                  val => val !== null && val !== '' || 'Please type your age', 
                  val => ageRule(val),
                ]
                "
              />
              <label>Password</label>
              <q-input 
                type="password" 
                reactive-rules 
                label-color="secondary" 
                filled 
                v-model="formData.password"
                label="Enter Password" 
                lazy-rules 
                :rules="formRules.password"
              />

              <label>Confirm Password</label>
              <q-input type="password" reactive-rules label-color="secondary" filled v-model="formData.confirmPassword"
                       label="Confirm Password" lazy-rules :rules="formRules.confirmPassword"/>


              <div class="q-gutter-sm">
                <q-checkbox 
                  size="xs" 
                  v-model="formData.agree_terms"
                  label="I Agree To The Terms And Conditions" 
                  :rules="formRules.agree_terms"
                />
              </div>

              <div class="submit">
                <div class="the-button">
                  <button type="submit" class="wro-button secondaryButtons"><span>Register</span>
                  </button>
                  <span class="skew-line-w"></span>
                </div>
                <!-- end send message  button -->
              </div>
            </q-form>

            <!-- activate email -->
            <q-form @submit="active_email" id="activate_from" v-if="registerationComplete && !resendCode">
              <q-input type="number" reactive-rules label-color="secondary" filled
                       v-model.number="formActivation.email_activation" label="Activate Number"
                       lazy-rules/>
              <div>
                <button-component>Active Email</button-component>

                <div class="the-button" style="margin-left: 30px" @click.prevent="resendCode = true">
                  <button class="wro-button secondaryButtons" type="button"><span>Resend Code</span></button>
                  <span class="skew-line-w"></span>
                </div>
              </div>
            </q-form>

            <!-- resend code -->
            <q-form @submit="resendCodeHandler" id="resend_code" v-if="resendCode">
              <q-input type="email" label-color="secondary" filled
                       v-model="resend.email" label="Enter Email"
                       lazy-rules/>
              <div>
                <button-component>Resend Code</button-component>
              </div>
            </q-form>

            <!-- end form -->
          </div>
        </div>

        <!-- registration image -->
        <div class="col-sm-12 col-md-6 register-img">
          <img src="@/assets/img/register/reimg.png">
        </div>
      </div>

      <q-dialog v-model="alert">
        <q-card>
          <q-card-section>
            <div class="text-h6">Alert</div>
          </q-card-section>

          <q-card-section class="q-pt-none">
            <p v-for="formError in formErrors" :key="formError.id">{{ formError }}</p>
            <p>{{ formDone[0] }}</p>
          </q-card-section>

          <q-card-actions align="right">
            <q-btn flat label="OK" color="primary" v-close-popup/>
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/components/tools/ButtonComponent.vue"
import ContactUs from "../home/ContactUs";

export default {
  props: ['reactivate', 'loginData'],
  data: () => ({
    formData: {
      name: '',
      email: '',
      password: '',
      confirmPassword: '',
      type: '',
      gender: '',
      age: '',
      agree_terms: false,
    },
    options: [{label: 'Male', value: 0}, {label: 'Female', value: 1}],
    userTypeOptions: [{label: 'Student', value: 0}, {label: 'Coach', value: 2}],
    formRules: {
      name: [val => val !== null && val !== '' || 'Please type your full name', val => val && val.length > 6 || 'Full name should be more than 6 letters'],
      email: [val => val !== null && val !== '' || 'Please type your email'],
      type: [val => val !== null && val !== '' || 'Please select your user type'],
      gender: [val => val !== null && val !== '' || 'Please select your gender'],
      // age: [val => val !== null && val !== '' || 'Please type your age', val => val <= 19 || 'Age should be up to 19'],
      password: [val => val !== null && val !== '' || 'Please type your password', val => val && val.length > 6 || 'Password should be strong'],
      confirmPassword: [val => val !== null && val !== '' || 'Confirm your password']
    },
    formActivation: {
      email_activation: '',
    },
    formErrors: [],
    alert: false,
    loading: false,
    formDone: [],
    registerationComplete: false,
    resendCode: false,
    resend: {}
  }),
  components: {ContactUs, ButtonComponent},
  mounted() {
    if (this.reactivate) {
      // this.resendCode = true;
      this.registerationComplete = true
    }
  },
  methods: {
    ageRule(val) {
      if (this.formData.type === 0 && val > 19) {
        return 'Age should be up to 19';
      } else if (this.formData.type === 2 && val > 50) {
        return 'Age should be up to 50';
      }
      return true;
    },
    register() {
      this.loading = true;
      this.formErrors = [];
      // if user dont agree terms
      if (this.formData.agree_terms !== true) {
        this.formErrors.push('You have to agree terms');
        this.alert = true;
        this.loading = false;
      } else if (this.formData.password !== this.formData.confirmPassword) {
        this.alert = true;
        this.loading = false;
        this.formErrors.push('Password confirm error');
      } else {
        this.$API.auth.register(this.formData)
            .then(response => {
              this.loading = false;
              // this.formDone.push(response.data.message + ' please active your email');
              // this.alert = true;
              // this.registerationComplete = true;
              // this.$emit('setLoginData', this.formData)

              let loginData = {
                email: this.formData.email,
                password: this.formData.password
              }

              this.$API.auth.login(loginData).then(res => {
                this.loading = false;
                this.$router.replace('/profile')
              }).catch(err => {
                this.loading = false;
                this.formErrors.push(err.response.data.message);
                this.alert = true;
              });
            })
            .catch(err => {
              this.loading = false;
              this.formErrors.push(err.response.data.message);
              this.alert = true;
            })
      }
    },
    active_email() {
      // EMPTY FORM DONE AND FORM ERRORS IS FOUND !
      this.formDone = '';
      this.formErrors = [];
      // POST EMAIL ACTIVE CODE
      this.$API.auth.activateEmail(this.formActivation)
          .then(() => {
            let loginData = {
              email: this.loginData.email,
              password: this.loginData.password
            }
            this.formDone = 'your account has been activated please login now !';
            // this.alert = true;
            // this.$router.push('/');
            this.$API.auth.login(loginData).then(res => {
              this.loading = false;
              this.$router.replace('/profile');
            }).catch(err => {
              this.loading = false;
              this.formErrors.push(err.response.data.message);
              this.alert = true;
            });

          })
          .catch(() => {
            this.formErrors.push('Code is not correct');
            this.alert = true;
          });
    },
    resendCodeHandler() {
      this.$API.auth.resendCode(this.resend)
          .then(response => {
            this.resendCode = false;
            this.registerationComplete = true;
            this.$emit('codeResend');
            this.$toastr.s(response.data)
          }).catch(error => {
        this.$toastr.e(error[0])
      })
    }
  },
}
</script>

<style>
.register-img img {
  width: 100%;
}
</style>